/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { getStudentAchievements } from 'src/services/api.service'
import { useCallback, useEffect, useState } from 'react'
import { AchievementsData } from 'src/services/dto'

export const StudentDashboardAwards = () => {
  const [data, setData] = useState<AchievementsData>()

  const fetch = useCallback(async () => {
    const response = await getStudentAchievements()
    setData(response.data.item)
  }, [])

  useEffect(() => {
    fetch()
  }, [])

  return (
    <>
      <div className="sectionHb-top">
        <h2 className="sectionHb-title">My achievements</h2>
      </div>
      <div className="sectionHb-block awards">
        <div className="sectionHb-block__wrap">
          <div className="awards-top">
            <i className="hb-ico awards-total" />
            <h3 className="awards-title">
              Total stars earned: <span>{data?.total_points}</span>
            </h3>
          </div>

          {/* <div className="dateBoard">
            <div className="dateBoard-head level-head">
              <div className="dateBoard-head__wrap">
                <div className="level-slider swiper-container swiper-container-initialized swiper-container-horizontal">
                  <div
                    className="level-slider__wrapper swiper-wrapper"
                    id="swiper-wrapper-8462b2fd681b0c0d"
                    aria-live="polite"
                  >
                    {data?.levels?.parent_levels}
                    <div
                      className="level-slide swiper-slide swiper-slide-visible swiper-slide-active"
                      role="group"
                      aria-label="1 / 6"
                    >
                      <div className="level-wrap level-blue">
                        <span className="level-title">Geometry</span>
                        <span className="level-name">Ms. Longsname</span>
                        <div className="level-row">
                          <b>Level</b>
                          <div className="level-circle">109</div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="level-slide swiper-slide swiper-slide-visible swiper-slide-next"
                      role="group"
                      aria-label="2 / 6"
                    >
                      <div className="level-wrap level-green">
                        <span className="level-title">Math</span>
                        <span className="level-name">Ms. Longsname</span>
                        <div className="level-row">
                          <b>Level</b>
                          <div className="level-circle">109</div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="level-slide swiper-slide swiper-slide-visible"
                      role="group"
                      aria-label="3 / 6"
                    >
                      <div className="level-wrap level-red">
                        <span className="level-title">Science</span>
                        <span className="level-name">Ms. Longsname</span>
                        <div className="level-row">
                          <b>Level</b>
                          <div className="level-circle">109</div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="level-slide swiper-slide swiper-slide-visible"
                      role="group"
                      aria-label="4 / 6"
                    >
                      <div className="level-wrap level-blue">
                        <span className="level-title">Geometry</span>
                        <span className="level-name">Ms. Longsname</span>
                        <div className="level-row">
                          <b>Level</b>
                          <div className="level-circle">109</div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="level-slide swiper-slide swiper-slide-visible"
                      role="group"
                      aria-label="5 / 6"
                    >
                      <div className="level-wrap level-green">
                        <span className="level-title">Math</span>
                        <span className="level-name">Ms. Longsname</span>
                        <div className="level-row">
                          <b>Level</b>
                          <div className="level-circle">109</div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="level-slide swiper-slide"
                      role="group"
                      aria-label="6 / 6"
                    >
                      <div className="level-wrap level-red">
                        <span className="level-title">Science</span>
                        <span className="level-name">Ms. Longsname</span>
                        <div className="level-row">
                          <b>Level</b>
                          <div className="level-circle">109</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span
                    className="swiper-notification"
                    aria-live="assertive"
                    aria-atomic="true"
                  />
                </div>
                <div
                  className="swiper-button-next"
                  tabIndex={0}
                  role="button"
                  aria-label="Next slide"
                  aria-controls="swiper-wrapper-8462b2fd681b0c0d"
                  aria-disabled="false"
                />
                <div
                  className="swiper-button-prev swiper-button-disabled"
                  tabIndex={-1}
                  role="button"
                  aria-label="Previous slide"
                  aria-controls="swiper-wrapper-8462b2fd681b0c0d"
                  aria-disabled="true"
                />
              </div>
            </div>
          </div> */}

          {/* <div className="awards-block">
            <div className="awards-block__img">
              <img src="/account/img/awards/img-1-min.png" alt="" />
            </div>
            <div className="awards-block__info">
              <div className="awards-block__top">
                <h3 className="awards-block__top-title">
                  Lego StarWars <span>waits at your 10 level you need</span>
                </h3>
                <span className="awards-block__top-stars">
                  <b>1215</b> stars!
                </span>
              </div>
              <div className="awards-bar">
                <div className="awards-bar__top">
                  <div className="awards-bar__text">
                    <i className="hb-ico awards-check" />
                    Earned <b>78</b>
                  </div>
                  <div className="awards-bar__text">
                    <i className="hb-ico awards-star-blue" />
                    <b>1215</b> to go
                  </div>
                </div>
                <div className="awards-bar__block">
                  <span style={{ width: '40%' }} />
                </div>
              </div>
            </div>
          </div> */}

          <div className="awards-sticker">
            <div className="awards-sticker__sidebar">
              {/* <div className="awards-sticker__sidebar-row">
                <div className="awards-sticker__card">
                  <span className="awards-sticker__sidebar-title">
                    <b>Mr James</b> award you a new sticker!
                  </span>
                  <div className="awards-sticker__sidebar-img">
                    <img src="/account/img/awards/img-3.svg" alt="" />
                  </div>
                  <ul className="awards-sticker__sidebar-list">
                    <li>
                      <a href="#" className="hb-ico print-ico" />
                    </li>
                    <li>
                      <a href="#" className="hb-ico download-ico" />
                    </li>
                  </ul>
                </div>
                <div className="awards-sticker__card">
                  <span className="awards-sticker__sidebar-title">
                    <b>Mr James</b> award you a new sticker!
                  </span>
                  <div className="awards-sticker__sidebar-img">
                    <img src="/account/img/awards/img-4.svg" alt="" />
                  </div>
                  <ul className="awards-sticker__sidebar-list">
                    <li>
                      <a href="#" className="hb-ico print-ico" />
                    </li>
                    <li>
                      <a href="#" className="hb-ico download-ico" />
                    </li>
                  </ul>
                  <a href="#" className="second-btn">
                    My stickers
                  </a>
                </div>
              </div> */}
            </div>
            <div className="awards-sticker__content">
              {(data?.stickers?.upcoming?.self_stickers || []).map((x) => (
                <div key={x.id} className="awards-sticker__item">
                  <div className="awards-bar">
                    <div className="awards-bar__head">
                      <div className="awards-bar__user">
                        <img src={x.sticker_image ?? '/account/img/awards/img-4.svg' } alt="" />
                      </div>
                      <span className="awards-bar__name">
                        {x.subject?.name}, {x.grade?.name} grade.{' '}
                        <b>{x.name}</b>
                      </span>
                    </div>

                    <div className="awards-bar__block color-red">
                      <span
                        style={{
                          width: `${
                            (100 / x.progress.total) * x.progress.earned
                          }%`,
                        }}
                      />
                    </div>

                    <div className="awards-bar__bottom">
                      <div className="awards-bar__text">
                        <i className="hb-ico awards-check" />
                        Earned <b>{x.progress.earned}</b>
                      </div>
                      <div className="awards-bar__text">
                        <i className="hb-ico awards-star" />
                        <b>{x.progress.total - x.progress.earned}</b> to go
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="awards-certificates">
            <div className="awards-top awards-top__second">
              <i className="hb-ico awards-icoCertificates" />
              <h3 className="awards-title">Certificates</h3>
            </div>
            {/* <div className="row awards-certificates__row">
              <div className="col-md-4 col-sm-6 awards-col">
                <div className="awards-certificates__wrap active">
                  <div className="awards-certificates__top">
                    <i className="hb-ico star-ico" />
                    <span>
                      <b>1000</b> points
                    </span>
                  </div>
                  <div
                    className="awards-certificates__img"
                    style={{
                      backgroundImage:
                        'url(/account/img/awards/img-2-min.jpg);',
                    }}
                  />
                  <div className="awards-certificates__bottom">
                    <a href="#" className="awards-certificates__print">
                      <i className="hb-ico print-ico" />
                      Print
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 awards-col">
                <div className="awards-certificates__wrap current">
                  <div className="awards-certificates__top">
                    <i className="hb-ico star-ico" />
                    <span>
                      <b>3000</b> points
                    </span>
                  </div>
                  <div
                    className="awards-certificates__img"
                    style={{
                      backgroundImage:
                        'url(/account/img/awards/img-2-min.jpg);',
                    }}
                  />
                  <div className="awards-certificates__bottom">
                    <div>
                      Earned <b>78</b>
                    </div>
                    <div>
                      <b>38</b> to go
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 awards-col">
                <div className="awards-certificates__wrap">
                  <div className="awards-certificates__top">
                    <i className="hb-ico star-ico" />
                    <span>
                      <b>5000</b> points
                    </span>
                  </div>
                  <div
                    className="awards-certificates__img"
                    style={{
                      backgroundImage:
                        'url(/account/img/awards/img-2-min.jpg);',
                    }}
                  />
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  )
}
